module.exports = __webpack_public_path__ + "img/ph_qrcode_viber.cf7ae06.png";